import request from '@/utils/request'
export function getDicts(dictType) {
  return request({
    url: '/app-api/system/dict-data/type?type=' + dictType,
    method: 'get'
  })
}
